import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  /** Monto ya formateado (`$522,000`). */
  value: string;
}

/** Replica `.mp-total`: barra en el azul de marca con la etiqueta y el total en blanco. */
export const BarTotal = ({ label, value }: Props) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { xs: "flex-start", sm: "center" },
      justifyContent: "space-between",
      gap: { xs: 0.25, sm: 1.5 },
      mt: "14px",
      p: "14px 16px",
      borderRadius: "12px",
      bgcolor: "primary.dark",
    }}
  >
    <Typography variant="body2" sx={{ color: "#fff", opacity: 0.82 }}>
      {label}
    </Typography>
    <Typography
      sx={{
        fontFamily: "Outfit",
        fontSize: 20,
        fontWeight: 600,
        letterSpacing: "-0.01em",
        color: "#fff",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {value}
    </Typography>
  </Box>
);
